import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Seo } from '../components/Seo';
import { usePageContent } from '../hooks/usePageContent';
import { SERVICE_AREAS } from '../lib/site';

const PORTRAIT = 'https://images.unsplash.com/photo-1778641603107-850c6a5f66c0?w=900';

const About = () => {
  const { t } = usePageContent('about');

  return (
    <div className="min-h-screen bg-[#1F1A17]">
      <Seo
        exactTitle="About | Mayden Films"
        description="Meet Darwin, the person behind Mayden Films — a premium mobile Glam Booth, photography and videography service across Southeast Melbourne."
        path="/about"
      />

      <section className="pt-36 pb-16 bg-gradient-to-br from-[#1F1A17] via-[#2A2420] to-[#1F1A17]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#EADBC8] mb-5">{t('hero_title', 'About Mayden Films')}</h1>
          <p className="text-base md:text-lg text-[#EADBC8]/70 max-w-2xl mx-auto">
            {t('hero_subtitle', 'A personal approach to helping people preserve the celebrations that matter most.')}
          </p>
        </div>
      </section>

      <section className="py-20 bg-[#1A1612]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img src={t('portrait_image', PORTRAIT)} alt="The Mayden Films Glam Booth" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -left-6 w-40 h-40 bg-[#C5A880] rounded-full opacity-10 blur-3xl" />
            </div>
            <div className="space-y-5 text-[#EADBC8]/80 text-base md:text-lg leading-relaxed">
              <p>{t('story_p1', <>Hi, I&rsquo;m <span className="text-[#C5A880] font-semibold">Darwin</span> — the person behind Mayden Films.</>)}</p>
              <p>{t('story_p2', 'I started doing photography, videography and photobooth for family and friends around 2017. It began as a hobby, and it quickly grew into a genuine passion. I\u2019ve always been inspired by — and truly love — capturing the beauty of life\u2019s cherished moments through my lens.')}</p>
              <p>{t('story_p3', 'I wish to do the same for my clients: to capture your special moments and turn them into memories you can hold on to for a lifetime — moments you can look back on and share as stories worth retelling.')}</p>
              <p>{t('story_p4', <>I aim to grow Mayden Films by treating every client&rsquo;s event with <span className="text-[#C5A880] font-semibold">Passion, Commitment and Artistry</span> — not just capturing memories, but the stories behind them.</>)}</p>
              <p>{t('story_p5', 'I keep bookings personal so each event receives careful preparation and genuinely personal service across Southeast Melbourne. My focus is the Glam Booth, and I\u2019m also happy to provide photography and videography when needed.')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#1F1A17]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#EADBC8] mb-8">{t('areas_title', 'Where I work')}</h2>
          <div className="flex flex-wrap justify-center gap-3">
            {SERVICE_AREAS.map((a) => (
              <span key={a} className="bg-[#2A2420] border border-[#C5A880]/20 text-[#EADBC8]/85 text-sm px-4 py-2 rounded-full">{a}</span>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-gradient-to-br from-[#2A2420] via-[#1F1A17] to-[#2A2420]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#EADBC8] mb-5">{t('cta_title', "Let's make your event unforgettable")}</h2>
          <Link to="/quote"><Button className="bg-[#C5A880] hover:bg-[#D4BC95] text-[#1F1A17] font-semibold px-10 py-6 text-base transition-transform duration-300 hover:scale-105">Check Your Event Date</Button></Link>
        </div>
      </section>
    </div>
  );
};

export default About;
